import React from 'react';
interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {}

export default function CloseButton({ ...rest }: Props) {
  return <button type="button" className="btn-close" aria-label="Close" {...rest}></button>;
}
